module.exports = __webpack_public_path__ + "static/media/cowboy-hat-icon.d5e14f06.svg";